// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.more-info {
    align-items: flex-start;
    background-color: var(--semantic-background-color-primary);
    display: flex;
    flex-direction: column;
    gap: 84px;
    padding: 58px 68px 52px;
    position: relative;
    width: 1512px;
}

.more-info .container {
    align-items: center;
    display: flex;
    gap: 84px;
    width: 100%;
}

.more-info .element {
    height: 485px;
    left: 341px;
    object-fit: cover;
    position: absolute;
    top: 59px;
    width: 509px;
    z-index: 1; /* Place this image under the macbook image */
}

.more-info .macbook-pro {
    width: 50%;
    height: auto; /* Maintain aspect ratio */
    z-index: 2;
}

.more-info .text-content {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 3; /* Place this image under the macbook image */
    gap: 10px;
}

.more-info .section-title {
    display: flex;
    flex-direction: column;
    gap: 16.8px;
    width: 100%;
}

.more-info .heading {
    color: var(--semantic-text-primary);
    font-family: var(--h-3-font-family);
    font-size: var(--h-3-font-size);
    font-style: var(--h-3-font-style);
    font-weight: var(--h-3-font-weight);
    letter-spacing: var(--h-3-letter-spacing);
    line-height: var(--h-3-line-height);
}

.more-info .text {
    color: var(--semantic-text-primary);
    font-family: var(--p-font-family);
    font-size: var(--p-font-size);
    font-style: var(--p-font-style);
    font-weight: var(--p-font-weight);
    letter-spacing: var(--p-letter-spacing);
    line-height: var(--p-line-height);
}




@media (max-width: 1224px) {
    .more-info {
        padding: 40px 20px; /* Adjust padding for smaller screens */
        gap: 40px; /* Reduce gap between elements */
    }

    .more-info .container {
        flex-direction: column;
        align-items: center;
        gap: 30px; /* Adjust gap between container items */
        width: 100%; /* Ensure container takes full width */
    }

    .more-info .macbook-pro {
        width: 100%; /* Full width for smaller screens */
    }

    .more-info .text-content {
        width: 100%; /* Full width for smaller screens */
    }

    .more-info .element {

        object-fit: cover; /* Ensure the image fills the container while maintaining its aspect ratio */

            width: 100%; /* Ensure the image takes up 100% of the container width */
            max-width: 100vw; /* Ensure the image does not exceed the viewport width */
            height: auto; /* Maintain aspect ratio */
            object-fit: cover; /* Ensure the image covers the container while maintaining aspect ratio */
            overflow: hidden; /* Hide any part of the image that exceeds the container */
            max-width: 100vw; 
        
    }
}

@media (max-width: 400px) {
    .more-info {
        padding: 30px 10px; /* Adjust padding for very small screens */
        gap: 20px; /* Reduce gap between elements */
        height: auto; /* Allow container to grow in height */
    }

    .more-info .container {
        flex-direction: column;
        align-items: center; /* Center children horizontally */
        gap: 20px; /* Adjust gap between container items */
        width: 100%; /* Ensure container takes full width */
        height: auto; /* Allow container to grow in height */
    }

    .more-info .macbook-pro {
        width: 100%; /* Full width for smaller screens */
    }

    .more-info .text-content {
        width: 100%; /* Full width for smaller screens */
    }

    .more-info .section-title {
        justify-content: center; /* Center content horizontally */
        align-items: center; /* Center content vertically */
        text-align: center; /* Center text within the flex container */
        width: 100%; /* Ensure section-title takes full width */
        height: auto; /* Adjust height as needed */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/MoreInfo/style.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,0DAA0D;IAC1D,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU,EAAE,6CAA6C;AAC7D;;AAEA;IACI,UAAU;IACV,YAAY,EAAE,0BAA0B;IACxC,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU,EAAE,6CAA6C;IACzD,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,+BAA+B;IAC/B,iCAAiC;IACjC,mCAAmC;IACnC,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;IACnC,iCAAiC;IACjC,6BAA6B;IAC7B,+BAA+B;IAC/B,iCAAiC;IACjC,uCAAuC;IACvC,iCAAiC;AACrC;;;;;AAKA;IACI;QACI,kBAAkB,EAAE,uCAAuC;QAC3D,SAAS,EAAE,gCAAgC;IAC/C;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS,EAAE,uCAAuC;QAClD,WAAW,EAAE,sCAAsC;IACvD;;IAEA;QACI,WAAW,EAAE,mCAAmC;IACpD;;IAEA;QACI,WAAW,EAAE,mCAAmC;IACpD;;IAEA;;QAEI,iBAAiB,EAAE,4EAA4E;;YAE3F,WAAW,EAAE,0DAA0D;YACvE,gBAAgB,EAAE,wDAAwD;YAC1E,YAAY,EAAE,0BAA0B;YACxC,iBAAiB,EAAE,yEAAyE;YAC5F,gBAAgB,EAAE,0DAA0D;YAC5E,gBAAgB;;IAExB;AACJ;;AAEA;IACI;QACI,kBAAkB,EAAE,0CAA0C;QAC9D,SAAS,EAAE,gCAAgC;QAC3C,YAAY,EAAE,sCAAsC;IACxD;;IAEA;QACI,sBAAsB;QACtB,mBAAmB,EAAE,iCAAiC;QACtD,SAAS,EAAE,uCAAuC;QAClD,WAAW,EAAE,sCAAsC;QACnD,YAAY,EAAE,sCAAsC;IACxD;;IAEA;QACI,WAAW,EAAE,mCAAmC;IACpD;;IAEA;QACI,WAAW,EAAE,mCAAmC;IACpD;;IAEA;QACI,uBAAuB,EAAE,gCAAgC;QACzD,mBAAmB,EAAE,8BAA8B;QACnD,kBAAkB,EAAE,0CAA0C;QAC9D,WAAW,EAAE,0CAA0C;QACvD,YAAY,EAAE,4BAA4B;IAC9C;AACJ","sourcesContent":["\n.more-info {\n    align-items: flex-start;\n    background-color: var(--semantic-background-color-primary);\n    display: flex;\n    flex-direction: column;\n    gap: 84px;\n    padding: 58px 68px 52px;\n    position: relative;\n    width: 1512px;\n}\n\n.more-info .container {\n    align-items: center;\n    display: flex;\n    gap: 84px;\n    width: 100%;\n}\n\n.more-info .element {\n    height: 485px;\n    left: 341px;\n    object-fit: cover;\n    position: absolute;\n    top: 59px;\n    width: 509px;\n    z-index: 1; /* Place this image under the macbook image */\n}\n\n.more-info .macbook-pro {\n    width: 50%;\n    height: auto; /* Maintain aspect ratio */\n    z-index: 2;\n}\n\n.more-info .text-content {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 3; /* Place this image under the macbook image */\n    gap: 10px;\n}\n\n.more-info .section-title {\n    display: flex;\n    flex-direction: column;\n    gap: 16.8px;\n    width: 100%;\n}\n\n.more-info .heading {\n    color: var(--semantic-text-primary);\n    font-family: var(--h-3-font-family);\n    font-size: var(--h-3-font-size);\n    font-style: var(--h-3-font-style);\n    font-weight: var(--h-3-font-weight);\n    letter-spacing: var(--h-3-letter-spacing);\n    line-height: var(--h-3-line-height);\n}\n\n.more-info .text {\n    color: var(--semantic-text-primary);\n    font-family: var(--p-font-family);\n    font-size: var(--p-font-size);\n    font-style: var(--p-font-style);\n    font-weight: var(--p-font-weight);\n    letter-spacing: var(--p-letter-spacing);\n    line-height: var(--p-line-height);\n}\n\n\n\n\n@media (max-width: 1224px) {\n    .more-info {\n        padding: 40px 20px; /* Adjust padding for smaller screens */\n        gap: 40px; /* Reduce gap between elements */\n    }\n\n    .more-info .container {\n        flex-direction: column;\n        align-items: center;\n        gap: 30px; /* Adjust gap between container items */\n        width: 100%; /* Ensure container takes full width */\n    }\n\n    .more-info .macbook-pro {\n        width: 100%; /* Full width for smaller screens */\n    }\n\n    .more-info .text-content {\n        width: 100%; /* Full width for smaller screens */\n    }\n\n    .more-info .element {\n\n        object-fit: cover; /* Ensure the image fills the container while maintaining its aspect ratio */\n\n            width: 100%; /* Ensure the image takes up 100% of the container width */\n            max-width: 100vw; /* Ensure the image does not exceed the viewport width */\n            height: auto; /* Maintain aspect ratio */\n            object-fit: cover; /* Ensure the image covers the container while maintaining aspect ratio */\n            overflow: hidden; /* Hide any part of the image that exceeds the container */\n            max-width: 100vw; \n        \n    }\n}\n\n@media (max-width: 400px) {\n    .more-info {\n        padding: 30px 10px; /* Adjust padding for very small screens */\n        gap: 20px; /* Reduce gap between elements */\n        height: auto; /* Allow container to grow in height */\n    }\n\n    .more-info .container {\n        flex-direction: column;\n        align-items: center; /* Center children horizontally */\n        gap: 20px; /* Adjust gap between container items */\n        width: 100%; /* Ensure container takes full width */\n        height: auto; /* Allow container to grow in height */\n    }\n\n    .more-info .macbook-pro {\n        width: 100%; /* Full width for smaller screens */\n    }\n\n    .more-info .text-content {\n        width: 100%; /* Full width for smaller screens */\n    }\n\n    .more-info .section-title {\n        justify-content: center; /* Center content horizontally */\n        align-items: center; /* Center content vertically */\n        text-align: center; /* Center text within the flex container */\n        width: 100%; /* Ensure section-title takes full width */\n        height: auto; /* Adjust height as needed */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
